import {IAlterationsState} from '../states'
import { AlterationsActionTypes, AlterationsTypeKeys } from '../types'

export const initialAlterationsState: IAlterationsState = {
  isAlterationsModalOpen: false,
  displayedActiveTickets: null
}

const alterations = (
  state: IAlterationsState = initialAlterationsState,
  action: AlterationsActionTypes
): IAlterationsState => {
  switch (action.type) {
    case AlterationsTypeKeys.SET_ALTERATIONS_MODAL_OPEN:
      return { ...state, isAlterationsModalOpen: action.payload }
    case AlterationsTypeKeys.SET_DISPLAYED_ACTIVE_TICKETS:
      return { ...state, displayedActiveTickets: action.payload }
    default:
      return state
  }
}

export default alterations
